import { render } from "./modalGaspillage.vue?vue&type=template&id=dbaf29e6&scoped=true"
import script from "./modalGaspillage.vue?vue&type=script&lang=js"
export * from "./modalGaspillage.vue?vue&type=script&lang=js"

import "./modalGaspillage.vue?vue&type=style&index=0&id=dbaf29e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbaf29e6"]])

export default __exports__